import React, { useMemo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Box, Flex, Text } from '@tonic-ui/react';
import ExploreResourceTile from './explore-resource-tile';

const ExploreResources = (): JSX.Element => {
  const { t } = useTranslation();
  const tiles = useMemo(
    () => [
      {
        heading: t('publicLandingPage.tileCarouselContent.tile1.heading'),
        description: t('publicLandingPage.tileCarouselContent.tile1.description'),
        linkText: t('publicLandingPage.tileCarouselContent.tile1.linkTxt'),
        linkUrl: t('publicLandingPage.tileCarouselContent.tile1.linkUrl'),
      },
      {
        heading: t('publicLandingPage.tileCarouselContent.tile2.heading'),
        description: t('publicLandingPage.tileCarouselContent.tile2.description'),
        linkText: t('publicLandingPage.tileCarouselContent.tile2.linkTxt'),
        linkUrl: t('publicLandingPage.tileCarouselContent.tile2.linkUrl'),
      },
      {
        heading: t('publicLandingPage.tileCarouselContent.tile3.heading'),
        description: t('publicLandingPage.tileCarouselContent.tile3.description'),
        linkText: t('publicLandingPage.tileCarouselContent.tile3.linkTxt'),
        linkUrl: t('publicLandingPage.tileCarouselContent.tile3.linkUrl'),
      },
      {
        heading: t('publicLandingPage.tileCarouselContent.tile4.heading'),
        description: t('publicLandingPage.tileCarouselContent.tile4.description'),
        linkText: t('publicLandingPage.tileCarouselContent.tile4.linkTxt'),
        linkUrl: t('publicLandingPage.tileCarouselContent.tile4.linkUrl'),
      },
    ],
    [t]
  );

  return (
    <Box>
      {/* Not shown, but the H2 is for hierarchy*/}
      <Text as="h2" visibility="hidden" height="0px">
        <Trans i18nKey="publicLandingPage.tileCarouselContent.title" />
      </Text>

      <Flex justifyContent="center">
        <Flex direction="row" gap="24px" justifyContent="center" flexWrap="wrap">
          {tiles.map((tile, i) => (
            <ExploreResourceTile key={i} {...tile} />
          ))}
        </Flex>
      </Flex>
    </Box>
  );
};

ExploreResources.displayName = 'ExploreResources';

export default ExploreResources;
